<template>
  <el-row style="height: 615px;width: 100%;margin-top: 80px;">
    <el-row style="width: 100%;height: 100px;">
      <el-row class="news-logo" />
    </el-row>
    <el-row style="width: 70%;height: 435px;margin-left: 15%;margin-top: 80px;">
      <el-row style="width: 100%;height: 45px;display: flex;font-size: 24px;">
        <el-col v-for="(item, i) in title" :key="i" style="width: 170px;height: 100%;">
          <el-row @click.native="clickTitle(i)" style="width: 150px;height: 100%;cursor: pointer;margin-left: 20px;" :class="i === selItem ? 'title-click-class' : 'title-class'">{{item.name}}</el-row>
        </el-col>
      </el-row>
      <el-row v-if="content.length > 0" style="width: 100%;height: 380px;margin-top: 10px;">
        <el-row v-for="(item, i) in content" :key="i" v-if="i % 2 === 0" style="width: 100%;height: 170px;margin-top: 20px;display: flex;">
          <el-col style="width: calc(50% - 25px);height: 140px;margin: 15px 0 15px 10px;text-align: left;display: flex;">
            <el-image :src="getImageUrl(content[i].newsCover)" class="img-class" fit="cover" @click.native="changeRoute('/news', content[i].id)"></el-image>
            <el-col style="width: calc(100% - 185px);height: 100%;margin-left: 15px;">
              <el-row style="width: 100%;height: 40px;line-height: 40px;">
                <el-col class="text-class" @click.native="changeRoute('/news', content[i].id)">
                  {{content[i].titleName}}
                </el-col>
                <el-col style="width: 30%;font-size: 14px;text-align: right;color: #969696;">
                  {{content[i].createTime}}
                </el-col>
              </el-row>
              <el-row style="height: calc(100% - 50px);margin-top: 10px;font-size: 14px;">
                {{content[i].remark}}
              </el-row>
            </el-col>
          </el-col>
          <el-col v-if="content.length > (i + 1)" style="width: calc(50% - 25px);height: 140px;margin: 15px 0 15px 30px;text-align: left;display: flex;">
            <el-image :src="getImageUrl(content[i + 1].newsCover)" class="img-class" fit="cover" @click.native="changeRoute('/news', content[i + 1].id)"></el-image>
            <el-col style="width: calc(100% - 185px);height: 100%;margin-left: 15px;">
              <el-row style="width: 100%;height: 40px;line-height: 40px;">
                <el-col class="text-class" @click.native="changeRoute('/news', content[i + 1].id)">
                  {{content[i + 1].titleName}}
                </el-col>
                <el-col style="width: 30%;font-size: 14px;text-align: right;color: #969696;">
                  {{content[i + 1].createTime}}
                </el-col>
              </el-row>
              <el-row style="height: calc(100% - 50px);margin-top: 10px;font-size: 14px;">
                {{content[i + 1].remark}}
              </el-row>
            </el-col>
          </el-col>
        </el-row>
      </el-row>
      <el-row v-else style="width: 100%;height: 380px;display: flex;align-items: center;justify-content: center;font-size: 32px;color: #00bf86">
        敬 请 期 待
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import axios from 'axios'
export default {
  name: 'News',
  data() {
    return {
      title: [{id: '1', name: '公司新闻'}, {id: '2', name: '行业动态'}],
      content: [],
      // newsList: [{id: '11', name: '2022年春节放假通知 ', img: require('../../assets/img/news/news4.png'), time: '2022-01-20'}],
      newsList: [],
      infoList: [],
      selItem: 0
    }
  },
  created() {
    this.$api.newsManage.getNewsInfo({page: 1, rows: 4, newsType: 0}).then(res => {
      if (res.code !== 500) {
        this.newsList = res.data.rows
        this.content = res.data.rows
      }
    })
    this.$api.newsManage.getNewsInfo({page: 1, rows: 4, newsType: 1}).then(res => {
      if (res.code !== 500) {
        this.infoList = res.data.rows
      }
    })
  },
  methods: {
    clickTitle(i) {
      this.selItem = i
      if (i === 0) {
        this.content = this.newsList
      } else {
        this.content = this.infoList
      }
    },
    getImageUrl(id) {
      return '/myApi/newsInfo/getImageById?id=' + id
    },
    changeRoute(path, id) {
      this.$router.push({path: path, query: {id: id}})
    }
  }
}
</script>

<style scoped>
  .news-logo {
    background: url("../../assets/news.png") no-repeat;
    width: 470px;
    margin-left: calc(50% - 235px);
    height: 100px;
    cursor: pointer;
  }
  .title-class {
    color: #000000;
  }
  .title-class:hover {
    color: #00bf86;
  }
  .title-click-class {
    color: #00bf86;
    border-bottom: 2px solid #00bf86;
  }
  .text-class {
    width: 70%;
    height: 100%;
    font-size: 20px;
    text-align: left;
    color: #000000;
    cursor: pointer;
    white-space:nowrap;
    text-overflow:ellipsis;
    overflow: hidden;
  }
  .text-class:hover {
    color: #00bf86;
  }
  .img-class {
    width: 170px;
    height: 140px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/News.vue